import { PatientDto } from '../dto/patient';
import { Gender, Race, Relationship, SexAssignedAtBirth } from '../enums/patient';
import { MembershipDto } from '../dto/membership';
import { DateTime } from 'luxon';
import { User } from './user';
import { AddressDto } from '@dto';

export class Patient {
  public readonly addressLatLng!: { lat: number; lng: number };
  public readonly id!: number;
  public readonly firstName!: string;
  public readonly lastName!: string;
  public readonly preferredName!: string;
  public readonly race!: Race;
  public readonly sexAssignedAtBirth!: SexAssignedAtBirth;
  public readonly gender!: Gender;
  public readonly relationToAccountHolder!: Relationship;
  public readonly dateOfBirth!: string;
  public readonly membership!: MembershipDto;
  public readonly email!: string;
  public readonly phone!: string;
  public readonly unreadCount!: number;
  public readonly patientNote!: string;
  public readonly deactivated!: boolean;
  public readonly active!: boolean;
  public readonly expired!: boolean;
  public readonly deleted!: boolean;
  public readonly inHomeVisitServiceRange?: boolean;
  public readonly user?: User;
  constructor(data: PatientDto) {
    Object.assign(this, data);
    if (data.user?.firstName) {
      this.firstName = data.user.firstName;
    }
    if (data.user?.lastName) {
      this.lastName = data.user.lastName;
    }
    if (data.user?.email) {
      this.email = data.user.email;
    }
  }

  get name() {
    return `${this.user?.firstName ? this.user.firstName : this.firstName} ${
      this.user?.lastName ? this.user.lastName : this.lastName
    }`;
  }

  get unifiedPreferredName(): string | undefined {
    return this.user?.preferredName ? this.user.preferredName : this.preferredName;
  }

  get ageInYears() {
    const years = DateTime.fromISO(this.user ? this.user.dateOfBirth : this.dateOfBirth)
      .diffNow('years')
      .negate()
      .toFormat('y', { floor: true });
    const age = Number(years);

    if (isNaN(age)) {
      return 0;
    }

    return age;
  }

  get is65Plus() {
    return this.ageInYears >= 65;
  }

  get companyName() {
    if (!this.membership || !this.membership.signUpDetails || !this.membership.signUpDetails.companyName) {
      return null;
    } else {
      return this.membership.signUpDetails.companyName;
    }
  }

  get fullAddress() {
    if (!this.user || (!this.user.address && !(this.user.addresses && this.user.addresses.length >= 0))) {
      return null;
    }

    // Only support a single address for time being
    const address = this.user.address ? this.user.address : this.user.addresses[0];
    return `${address.address1}${address.address2 ? ` ${address.address2}` : ''}, ${address.city}, ${address.state}, ${
      address.zip
    }`;
  }

  get address(): AddressDto | null {
    let theAddress: AddressDto | null = null;

    if (!this.user) {
      return theAddress;
    }

    if (this.user.address) {
      theAddress = this.user.address;
    } else if (this.user.addresses && this.user.addresses.length > 0) {
      theAddress = this.user.addresses[0];
    }

    return theAddress;
  }

  get membershipTypeName() {
    if (!this.membership || !this.membership.membershipType) {
      return null;
    }

    return this.membership.membershipType.membershipName;
  }
}
